module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABHklEQVR4Ae3MMSjEYRzG8U/MIEU5dekm3S6bvZRdmVhMgtj3vexlMlAi5TIgZWYAizr7QIT0U/9s7nXvddt132d86qPD6jZs0aFbr8K3C5sqWq5s26f4syNjWmjOu2i4XT2yWxG/O7dhyqB+VQtq9vXKblYUuzetjca8CeHasLbaEULdqP8rOVOSbEIUm2nKPAlPaWpNCKdZTEhTTop7OZNJUx6Ks5rNJKmv4hpoyiSosnqDu64sVZ8QXv2poLIZJoXwSILKZFgWQo0ElclwKoR1klQWMyOKVUhTV02ZUc9C2NFWI26E8KakjaY9iGKzsuu1p2Ze1YAhUzZcit+tyq7Hrmi4D3NaaNxxQ2TbuJar2HLhW3hx58CSIR1Vtx8sxcxOrHtALwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/reload.png
// module id = 413
// module chunks = 0